import { useHelpMenuQuery } from '../../hooks/use-helpmenu';
import { useMemo } from 'react';
import { NavItem } from '@im/ui-lib/nav';
import { useLocalizationContext } from '@im/react-localization';
import { buildHelpMenuItem } from './utils';

export function useHelpNavItems() {
  const { locale } = useLocalizationContext();
  const { data: help } = useHelpMenuQuery(locale);
  return useMemo<NavItem[]>(() => {
    return buildHelpMenuItem(help?.items);
  }, [help?.items]);
}
